import { render, staticRenderFns } from "./V.vue?vue&type=template&id=a02aa0a0&scoped=true"
import script from "./V.vue?vue&type=script&lang=js"
export * from "./V.vue?vue&type=script&lang=js"
import style0 from "./V.vue?vue&type=style&index=0&id=a02aa0a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02aa0a0",
  null
  
)

export default component.exports